enum BaseConfigItems {
  ESS = 'Employee Self Service',
  // TODO: Hide MR request by 1631 task
  MR = 'Material Request',
  DASHBOARD = 'Dashboard',
  CONTACTS = 'Contacts',
  TBMS = 'TBMS 1.0',
  REPORT_ISSUE = 'Report an Issue',
  RAISE_REQUEST = 'Raise a Request',
}

export default BaseConfigItems;
